import { RouteObject } from "react-router";

import PageError from "@/shared/ui/errors/PageError";
import * as Sentry from "@sentry/react";

export const JobRoutes: RouteObject = {
	path: "/jobs/*",
	children: [
		{
			path: "email/competency/*",
			children: [
				{
					index: true,
					lazy: async () => {
						const { CompetencyEmailJobs } =
							await import("@/components/Jobs/CompetencyEmailJobs");
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={(boundary) => (
										<PageError
											error={boundary.error}
											componentStack={boundary.componentStack}
											reset={() => boundary.resetError()}
										/>
									)}
								>
									<CompetencyEmailJobs />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
				{
					path: ":id",
					lazy: async () => {
						const { CompetencyEmailJobs } =
							await import("@/components/Jobs/CompetencyEmailJobs");
						return {
							Component: () => (
								<Sentry.ErrorBoundary
									fallback={(boundary) => (
										<PageError
											error={boundary.error}
											componentStack={boundary.componentStack}
											reset={() => boundary.resetError()}
										/>
									)}
								>
									<CompetencyEmailJobs />
								</Sentry.ErrorBoundary>
							),
						};
					},
				},
			],
		},
	],
};
